// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"dcefc5cb","183":"b6423743","285":"b2c13b04","679":"7b8e9f1e","723":"2594d6a1","787":"ad1491e5"}[chunkId] + ".chunk.js";
};